import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '$partials/ui';
import { Dispatcher as ItemDispatcher } from '$partials/listings';
import { useLanguage } from '$contexts/language.jsx';
import { StaticTitle } from '$partials/layout/side-titles.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ContactPeople = ({
    page      = null,
    sideTitle = null,
    title     = null,
}) => {
    // hooks
    const { translate: t } = useLanguage();

    // render
    return (
        <section className='module-contact-people'>
            <div className='pr-gutter mxn-gutter'>  {/* outer grid gutter */}
                <div className='flex flex-wrap mb6 sm-mb8 md-mb9'>
                    {/* side title */}
                    <div className='absolute md-relative md-col-2'>
                        {(title && sideTitle) && (
                            <div className='px-gutter'>
                                <p className='type-style-5 side-title side-title--lesser-top'>
                                    <StaticTitle title={sideTitle} />
                                </p>
                            </div>
                        )}
                    </div>

                    {/* content / title */}
                    <div className='col-11 sm-col-8 md-col-7'>
                        <div className='ml9 sm-ml9 md-m0'>
                            <div className='px-gutter'>
                                <div
                                    className='rich-text type-style-3'
                                    dangerouslySetInnerHTML={{ __html: title }} />

                                {page?.emailAddress && (
                                    <Button
                                        className='button mb7 mt5'
                                        href={`mailto:${page?.emailAddress}`}
                                        rel='nooppener noreferrer'
                                        target='_blank'>
                                        <span className='capitalise'>
                                            {t('Contact')}
                                        </span>
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* people item */}
                    {page && (
                        <div className='col-10 sm-col-5 md-col-3'>
                            <div className='ml9 sm-ml9 md-m0'>
                                <div className='px-gutter'>
                                    <ItemDispatcher item={page} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    page     : PropTypes.object,
    sideTitle: PropTypes.string,
    title    : PropTypes.string,
};

ContactPeople.propTypes = propTypes;

export { ContactPeople };

export default ContactPeople;
